import type { CobranzaPaymentStatus } from '@yawi/types';

const currencyFormatter = new Intl.NumberFormat('es-MX', {
  style: 'currency',
  currency: 'MXN',
  maximumFractionDigits: 0,
});

export const formatCurrency = (amount: number): string => currencyFormatter.format(amount);

export const formatDate = (iso: string): string => {
  if (!iso) return '—';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleDateString('es-MX', { day: '2-digit', month: 'short', year: 'numeric' });
};

export interface StatusMeta {
  label: string;
  badge: string; // clases tailwind para el badge
}

export const PAYMENT_STATUS_META: Record<CobranzaPaymentStatus, StatusMeta> = {
  current: { label: 'Al día', badge: 'bg-emerald-50 text-emerald-700 ring-1 ring-emerald-200' },
  pending: { label: 'Pendiente', badge: 'bg-amber-50 text-amber-700 ring-1 ring-amber-200' },
  overdue: { label: 'Vencido', badge: 'bg-red-50 text-red-700 ring-1 ring-red-200' },
};
